/** @jsxImportSource ./simboluri-jsx */
import type { Proeminenta } from "./tipuri";
import { useT } from "../i18n";

// ETAJUL RETRAS: proeminență sau nivel (P100-1 §8.3.2.2(5)), cu calculul
// încadrării pe secțiuni, cum îl scrie Pasul 3 (`zidarie_confinata.sectiuni`):
// ce compară normativul, suprafața nivelului curent, încăperile etajului
// retras, raportul, înălțimea și structura — decizia separată. Textele vin
// gata scrise de server, în aceeași formă ca deciziile pasului.
export default function ProeminentaCalcul({ p }: { p?: Proeminenta | null }) {
  const t = useT();
  if (!p || p.nivel == null || !(p.sectiuni ?? []).length) return null;
  return (
    <div className="st-findings">
      <h3>
        {t("struct.strateg.proeminenta_titlu", { nivel: p.nume ?? "" })}
        {" — "}
        <span style={{ color: p.aplicat ? "#2e7d32" : "#b5323d" }}>
          {t(p.aplicat ? "struct.strateg.proeminenta_da" : "struct.strateg.proeminenta_nu")}
        </span>
      </h3>
      <div className="sg-muted" style={{ marginBottom: 8 }}>{p.motiv}</div>
      {p.sectiuni.map((s) => (
        <div key={s.cheie} style={{ marginBottom: 10 }}>
          <h4 style={{ margin: "8px 0 4px" }}>{s.titlu}</h4>
          {s.text && <div style={{ marginBottom: 4 }}>{s.text}</div>}
          {s.linii.length > 0 && (
            <table className="sg-table">
              <tbody>
                {s.linii.map((l, i) => (
                  <tr key={i}>
                    <td>{l.ce}</td>
                    <td className="sg-mono" style={{ whiteSpace: "nowrap" }}>{l.valoare}</td>
                    <td className="sg-muted">{l.nota ?? ""}</td>
                  </tr>
                ))}
                {s.rezultat && (
                  <tr style={{ fontWeight: 600 }}>
                    <td>{s.rezultat.ce}</td>
                    <td className="sg-mono" style={{ whiteSpace: "nowrap" }}>{s.rezultat.valoare}</td>
                    <td />
                  </tr>
                )}
              </tbody>
            </table>
          )}
          {!s.linii.length && s.rezultat && (
            <div style={{ fontWeight: 600 }}>{s.rezultat.ce}: {s.rezultat.valoare}</div>
          )}
        </div>
      ))}
    </div>
  );
}
